module.exports = __webpack_public_path__ + "img/solution_communitycare.69d48750.jpg";